import { formatNumber, LinearProgressChart, LinearProgressListItem, NumberFormatPreset } from '@procureai/ui-mui';
import { isNotNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export const NegotiationCaseCountListitem = ({
  loading,
  value,
  variant,
  min,
  max,
}: {
  loading?: boolean;
  value?: number | null;
  min?: number;
  max?: number;
  variant: any;
}) => {
  const { t } = useTranslation(I18nNamespace.base, { keyPrefix: 'NegotiationStatisticsWidget' });
  const formatPercentage = formatNumber(NumberFormatPreset.PERCENT);
  if (!value || loading) {
    return (
      <LinearProgressListItem
        primary={t(`label.${variant}`)}
        primaryRight=""
        secondary={t(loading ? 'label.loading' : 'label.noData')}
      />
    );
  }

  const showChart = isNotNil(min) && isNotNil(max);
  const percentage = max ? value / max : undefined;
  return (
    <LinearProgressListItem
      primary={t(`label.${variant}`)}
      primaryRight={value}
      secondaryRight={percentage ? formatPercentage(percentage) : undefined}
    >
      {showChart && <LinearProgressChart value={value} min={min} max={max} />}
    </LinearProgressListItem>
  );
};
